import YouTube from "simple-youtube-api";

export const getSearchedSongs = async (query) => {
  const youtube = new YouTube("AIzaSyAdUhWg-e19b8B26_vqG02OpvkOMItVzJs");
  let res = await youtube
    .searchVideos(query, 12)
    .then((results) => {
      return results;
    })
    .catch(console.log);
  return res;
};
